import { httpRequest } from "@utils/HttpRequest";
import { IPage } from "@src/types/FmsTypes";
import { trasDsToTreeData } from "./menuModel";
import { IMdMenuDetail, IMdMenuFields, IMdMenuSearch } from "./MenuTypes";

class MenuService {

    /**
     * 新增菜单
     * @param params 
     * @returns 
     */
    async insert(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/insert";
        return await httpRequest.post<IMdMenuDetail>(apiUrl, params);
    }

    /**
     * 修改菜单
     * @param params 
     * @returns 
     */
    async update(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/update";
        return await httpRequest.post<IMdMenuDetail>(apiUrl, params);
    }

    /**
     * 删除菜单
     * @param menuCode 
     * @returns 
     */
    async remove(menuCode: string) {
        const apiUrl = `/auth/menu/remove/${menuCode}`;
        return await httpRequest.post<IMdMenuDetail>(apiUrl);
    }

    /**
     * 查询菜单
     * @param params 
     * @returns 
     */
    async find(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/find";
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl, params)
    }

    /**
     * 查询菜单详情
     * @param code 
     * @returns 
     */
    async findOne(menuCode: string) {
        const apiUrl = `/auth/menu/findOne/${menuCode}`;
        return await httpRequest.post<IMdMenuDetail>(apiUrl)
    }

    /**
     * 查询菜单资源信息
     * @param menuCode 
     * @returns 
     */
    async findMenuResources(menuCode: string) {
        const apiUrl = `/auth/menu/findMenuResource/${menuCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }


    /**
     * 查询菜单树
     * @param menuCode 
     * @returns 
     */
    async findTree(menuCode: string) {
        const apiUrl = `/auth/menu/findTree/${menuCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 根据应用查询菜单树
     * @param appCode 
     * @returns 
     */
    async findTreeByApp(appCode: string) {
        const apiUrl = `/auth/menu/findTreeByApp/${appCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 根据角色查询菜单树
     * @param roleCode 
     * @returns 
     */
    async findTreeByRole(roleCode: string) {
        const apiUrl = `/auth/menu/findTreeByRole/${roleCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 根据角色和应用查询菜单树
     * @param roleCode 
     * @param appCode 
     * @returns 
     */
    async findTreeByRoleAndApp(roleCode: string, appCode: string) {
        const apiUrl = `/auth/menu/findTreeByRoleApp/${roleCode}/${appCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 根据用户和应用查询菜单树
     * @param userCode 
     * @param appCode 
     * @returns 
     */
    async findTreeByUserAndApp(userCode: string, appCode: string) {
        const apiUrl = `/auth/menu/findTreeByUserApp/${userCode}/${appCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 查询应用的菜单树
     * @returns 
     */
    async findTreeWithAllApp() {
        const apiUrl = `/auth/menu/findTreeWithAllApp`;
        const { retData } = await httpRequest.post<IMdMenuDetail[]>(apiUrl)
        // retData.forEach(item => {
        //     item.children = item.children && item.children.length > 0 ? trasDsToTreeData(item?.children as IMdMenuFields[], "code", "name") : [];
        // })
        return retData;
    }

    /**
     * 查询角色选择的菜单项
     * @returns 
     */
    async findMenuListByRole(roleCode: string) {
        const apiUrl = `/auth/menu/findParallelMenuListByRole/${roleCode}`;
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl)
    }

    /**
     * 分页查询菜单树
     * @param params 
     * @returns 
     */
    async page(params: IMdMenuSearch) {
        const apiUrl = "/auth/menu/findPage";
        return await httpRequest.post<IPage<IMdMenuDetail>>(apiUrl, params)
    }

    /**
     * 更新菜单资源信息
     * @param params 
     * @returns 
     */
    async updateMenuResource(params: IMdMenuDetail) {
        const apiUrl = "/auth/menu/updateMenuResources";
        return await httpRequest.post<boolean>(apiUrl, params)
    }





    async dictItemDs(pcode: string,) {
        let { retData } = await this.find({ pcode })
        return retData.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        }))
    }

    async one(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/one";
        return await httpRequest.post<IMdMenuDetail>(apiUrl, params)
    }

    async allTree(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/allTree";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<IMdMenuDetail[]>(apiUrl, params)
    }

    async oneTree(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/oneTree";
        return await httpRequest.post<IMdMenuDetail>(apiUrl, params)
    }

    async oneTreeDs(params: IMdMenuFields) {
        let { retData } = await this.oneTree(params);
        let { children } = retData
        return children ? children.map(el => ({
            label: el.name ?? "",
            value: el.code ?? ""
        })) : []
    }

    async sync(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/sync";
        // params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async syncPage(params: IMdMenuSearch) {
        const apiUrl = "/auth/menu/syncPage";
        params.branchList = ["main", "fms"];
        return await httpRequest.post<boolean>(apiUrl, params)
    }

    async syncOne(params: IMdMenuFields) {
        const apiUrl = "/auth/menu/syncOne";
        return await httpRequest.post<boolean>(apiUrl, params)
    }
    async accountTreeOne(code: string) {
        let { retData } = await this.allTree({ code })
        // return retData.map(el => ({
        //     label: el.name ?? "",
        //     value: el.code ?? "",
        //     codes: el.value ?? "",
        // }))
        let { children } = retData[0]
        console.log(retData)
        let treeData = trasDsToTreeData(children as IMdMenuFields[], "code", "name");
        return treeData;
    }
}
export const menuService = new MenuService();
